import noop from "lodash/noop";

import type { UseBrazeSDK } from "@/hooks/useBrazeSDK/types";

const useBrazeSDK = (): UseBrazeSDK => ({
  identifyBraze: noop,
  resetBraze: noop,
});

export default useBrazeSDK;
